module.exports = __webpack_public_path__ + "static/samW-aff12064ecbb2fcca2ba1346cce5bddc.jpg";